





























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import BaseButton from "@/components/BaseButton";
import BaseList, { BaseListItem } from "@/components/BaseList";
import EmptyContent from "@/components/EmptyContent";
import PageTitle from "@/components/PageTitle";
import CardItem from "../CardItem";

@Component({
  name: "CardListView",
  components: { CardItem, PageTitle, BaseList, BaseListItem, BaseButton, EmptyContent },
})
export default class CardListView extends Vue {
  @Prop({ required: true })
  public readonly cards!: CreditCardAssignment[];
}
